import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "wheel"
const WheelIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm6.966-1.937-4.138 1.109A3.987 3.987 0 0 0 12 8a3.987 3.987 0 0 0-2.828 1.172L5.034 8.063A7.997 7.997 0 0 1 12 4a7.998 7.998 0 0 1 6.966 4.063ZM14 15.465v4.283a8.003 8.003 0 0 0 6-7.821l-4.135 1.108A4.009 4.009 0 0 1 14 15.465ZM4 11.927V12c0 3.728 2.55 6.86 6 7.748v-4.283a4.009 4.009 0 0 1-1.865-2.43L4 11.927Z"
      />
    </svg>
  )
}
export default WheelIcon
